module.exports = __webpack_public_path__ + "img/productHome1.1bd39103.png";